export default {
    namespaced: true,
    state: {
        contrata: -1,
    },
    getters: {
        getContrataForVehicle(state) {
            return state.contrata
        },
    },
    mutations: {
        SET_CONTRATA(state, val) {
            state.contrata = val
        }
    },
    actions: {
        updateContrataForVehicle({ commit }, value) {
            commit('SET_CONTRATA', value)
        }
    }
}